const formatArticlePublishedAt = (value: string): string => {
    const [date, time] = new Date(value).toISOString().split('T');
    const [hour, minute] = time.split(':');
    return `${date} ${Number(hour) || 24}:${minute}`;
};

export default formatArticlePublishedAt;
